export default __webpack_public_path__ + "static/media/pinterest.ab676f21.svg";